export default __webpack_public_path__ + "static/motel-bedroom-0b5d30c31f595133de1d0b6e28e31f05.jpg";